import { makeStyles } from 'tss-react/mui'

export const getOrMakeStyles = makeStyles()(() => ({
    view: {
        height: 40,
        minWidth: 240,
        maxWidth: 240
    }
}))
